module.exports = __webpack_public_path__ + "assets/img/位图@2x.8bfdd97f.png";